import Plugin from 'src/plugin-system/plugin.class';
import anime from 'animejs/lib/anime.es.js';

export default class ProductHeroImagesPlugin extends Plugin {

    init() {
        this._resizeImage();
        this._registerEvents();
    }

    _registerEvents() {

        $( window ).on('resize', () => {
            this._resizeImage();
        });

        var that = this;

        var mainImageHeight = $(".product-hero-widget__main-image").height();
        $(".product-hero-widget__main-image-wrapper").height(mainImageHeight);

        var images = this.el.querySelectorAll(".product-hero-widget__gallery-image-wrapper");

        images.forEach((item, i) => {
            item.addEventListener("click", function(e) {
                e.preventDefault();

                var newSrc = $(item).find('img').attr('src');

                if ($('.product-hero-widget__new-image').attr('src') == '') {
                    $('.product-hero-widget__new-image').attr('src', newSrc);

                    anime.timeline({ loop: false })
                        .add({
                            targets: '.product-hero-widget__main-image',
                            opacity: 0,
                            easing: "easeInOutQuad",
                            duration: 500,
                            complete: function() {
                                that._resizeImage();
                                document.querySelector('.product-hero-widget__main-image').style.visibility = 'hidden';
                            }
                        })
                        .add({
                            targets: '.product-hero-widget__new-image',
                            opacity: 1,
                            delay: 500,
                            easing: "easeInOutQuad",
                            duration: 500
                        });
                } else {
                    var img = document.createElement('img');
                    img.src = newSrc;
                    document.querySelector('.product-hero-widget__main-image-wrapper').appendChild(img);
                    $(img).addClass('product-hero-widget__new-image');

                    anime.timeline({ loop: false })
                        .add({
                            targets: '.product-hero-widget__new-image',
                            opacity: 0,
                            easing: "easeInOutQuad",
                            duration: 500,
                            complete: function() {
                                that._resizeImage();
                                $('.product-hero-widget__new-image').first().remove();
                            }
                        })
                        .add({
                            targets: '.product-hero-widget__new-image',
                            opacity: 1,
                            easing: "easeInOutQuad",
                            duration: 500
                        });

                    //$('.product-hero-widget__new-image').first().remove();
                }

                $('.product-hero-widget__gallery-item').removeClass('is--active');
                $(item).parent('.product-hero-widget__gallery-item').addClass('is--active');

                window.scrollTo({
                    top: $('.product-hero-widget__top-section').scrollTop(), 
                    left: 0,
                    behavior: 'smooth'
                });
            });
        });
    }

    _resizeImage() {

        if ($('.product-hero-widget__new-image').attr('src') == '') {
            var height = $('.product-hero-widget__main-image').height();
        } else {
            var height = $('.product-hero-widget__new-image').height();
        }

        $(".product-hero-widget__main-image-wrapper").height(height);
    }

}